import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Button } from "@material-ui/core";
import SearchArea from './SearchArea';
import GeneralService from '../apis/GeneralService';
import { Panel } from 'primereact/panel';
import moment from 'moment';
import { NotificationManager } from 'react-notifications';
import * as XLSX from "xlsx";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#3C8DBC",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

export default function ConsultaDeuda() {
  const classes = useStyles();

  const [showTable, setShowTable] = React.useState(false);
  const [data, setData] = React.useState([]); // ← SIEMPRE array
  const [toPay, setToPay] = React.useState(0);

  const exportarExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      data.map(row => ({
        NOMBRE: `${row.proApellido} ${row.proNombre}`,
        Tributo: row.trbNombre,
        Titulo: row.trcNumeroTitulo,
        Antecedente: row.antecedentes,
        "Clave Catastral": row.hegClaveCatastral,
        "Valor Emitido": row.trcValorEmitido,
        Descuento: row.trc_valor_descuento,
        Recargo: row.trc_valor_recargo,
        Interes: row.trc_valor_interes,
        Total: row.trc_total_cobro,
        Estado: row.estado
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Listado");
    XLSX.writeFile(workbook, "listado.xlsx");
  };

  const searchAction = (credentialValue) => {
    setShowTable(false);

    GeneralService.getDebts(credentialValue).then(result => {
      if (typeof result.data.status !== "undefined") {
        NotificationManager.error(result.data.status.msg, "", 5000);
      } else {
        setData(result.data);

        let calculatedValue = 0;
        result.data.forEach(record => {
          calculatedValue += Number(record.trc_total_cobro) + Number(record.trc_iva);
        });

        setToPay(calculatedValue);
        setShowTable(true);
      }
    }, () => {
      NotificationManager.error("Error en consulta, intente más tarde.", "", 5000);
    });
  };

  return (
    <React.Fragment>
      <Panel header={`Estado de Cuenta al: ${moment().format("YYYY-MM-DD")}`}>
        <SearchArea searchAction={searchAction} />
      </Panel>
      <br />
      <br />
      <table>
        <tbody>
          <tr>
            <td align="center">
              <a
                href="https://pagos.facilito.com.ec/aplicacion/facilito"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-pago-linea"
              >
                <img
                  src={require("../../assets/images/pagoEnLinea.png")}
                  alt="Pago en línea"
                  style={{
                    width: "120px",   // 👈 tamaño del icono
                    height: "120px",  // 👈 tamaño del icono
                    marginRight: "10px"
                  }}
                />
                PAGO EN LÍNEA
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <br />

      <Panel header={`Valor Total: $${toPay.toFixed(2)}`} style={{ fontSize: "25px" }}>
        {showTable && (
          <TableContainer component={Paper}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={11} align="right">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={exportarExcel}
                    >
                      Exportar a Excel
                    </Button>
                  </StyledTableCell>
                </TableRow>

                <TableRow>
                  <StyledTableCell>NOMBRE</StyledTableCell>
                  <StyledTableCell>Tributo</StyledTableCell>
                  <StyledTableCell>Titulo</StyledTableCell>
                  <StyledTableCell>Antecedente</StyledTableCell>
                  <StyledTableCell>Clave Catastral</StyledTableCell>
                  <StyledTableCell>Valor Emitido</StyledTableCell>
                  <StyledTableCell>Descuento</StyledTableCell>
                  <StyledTableCell>Recargo</StyledTableCell>
                  <StyledTableCell>Interes</StyledTableCell>
                  <StyledTableCell>Total</StyledTableCell>
                  <StyledTableCell>Estado</StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data.map(row => (
                  <StyledTableRow key={row.hegClaveCatastral}>
                    <StyledTableCell>{row.proApellido} {row.proNombre}</StyledTableCell>
                    <StyledTableCell>{row.trbNombre}</StyledTableCell>
                    <StyledTableCell>{row.trcNumeroTitulo}</StyledTableCell>
                    <StyledTableCell>{row.antecedentes}</StyledTableCell>
                    <StyledTableCell>{row.hegClaveCatastral}</StyledTableCell>
                    <StyledTableCell>${row.trcValorEmitido}</StyledTableCell>
                    <StyledTableCell>${row.trc_valor_descuento}</StyledTableCell>
                    <StyledTableCell>${row.trc_valor_recargo}</StyledTableCell>
                    <StyledTableCell>${row.trc_valor_interes}</StyledTableCell>
                    <StyledTableCell>${row.trc_total_cobro}</StyledTableCell>
                    <StyledTableCell>{row.estado}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Panel>
    </React.Fragment>
  );
}
